import create from "zustand";
import { devtools } from "zustand/middleware"

import { getIllustrationFolders, getIllustrationInFolders, downloadIllustration } from '../api/illustration.api'

const illustrations = (set, get) => ({
	IllustrationFolders: null,
    IllustrationInFolders: null,
    Illustration: null,
	illustrationFolderId: null,

    getIllustrationFolders: async () => {
		set({ IllustrationFolders: "loading" })
		await getIllustrationFolders().then((r) => {
			if(r.data.response_code === '01'){
				set({ IllustrationFolders: r.data.resp })
			}else{
				set({ IllustrationFolders: false })
			}
		})
	},

    getIllustrationInFolders: async (id) => {
		set({ IllustrationInFolders: "loading" })
		await getIllustrationInFolders(id).then((r) => {
			if(r.data.response_code === '01'){
				set({ IllustrationInFolders: r.data.resp })
			}else{
				set({ IllustrationInFolders: false })
			}
		})
	},

    downloadIllustration: async (id) => {
		const data = downloadIllustration(id)
		return data
	}
});

const illustrationsStore = create(
    devtools(illustrations)
);

export default illustrationsStore